import { Button } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import { FeebackButtonProps } from "./FeedbackButton.decl";

import { useTrack } from "@/hooks/useTrack/useTrack";

export function FeedbackButton({
  event,
  text,
  "data-test": dataTest = "feedback-button",
  ...rest
}: FeebackButtonProps) {
  const { t } = useTranslation();
  const { track } = useTrack();

  const onClick = () => {
    track(event);
  };

  return (
    <Button
      size="xSmall"
      variant="secondary"
      data-test={dataTest}
      onClick={onClick}
      {...rest}
    >
      {text ?? t("feedback_button")}
    </Button>
  );
}
